import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { graphql, readInlineData } from "react-relay";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { currentArticleAtom } from "scmp-app/lib/current-item";
import { useArticleCommentLink } from "scmp-app/lib/hooks";
import type { commentHeaderFeaturesArticle$key } from "scmp-app/queries/__generated__/commentHeaderFeaturesArticle.graphql";

import IconComment from "./comment.svg";
import {
  Container,
  StyledArticleCommentsTrigger,
  StyledArticleCommentsTriggerButton,
} from "./styles";

export type HeaderFeaturesCommentProps = HeaderFeatureCommonProps;

export const HeaderFeaturesComment: FunctionComponent<HeaderFeaturesCommentProps> = ({
  ...props
}) => {
  const currentArticle = useAtomValue(currentArticleAtom);
  const { toggleByUrl: toggleCommentByUrl } = useArticleCommentLink();

  if (!currentArticle) return null;

  if (currentArticle.__typename === "Video") {
    return (
      <Container {...getResponsiveProps(props)}>
        <StyledArticleCommentsTriggerButton
          commentCount={0}
          icon={<IconComment />}
          onClick={toggleCommentByUrl}
        />
      </Container>
    );
  }

  const article = readInlineData<commentHeaderFeaturesArticle$key>(
    graphql`
      fragment commentHeaderFeaturesArticle on Article @inline {
        ...articleCommentsTriggerArticle
      }
    `,
    currentArticle,
  );

  return (
    <Container {...getResponsiveProps(props)}>
      <StyledArticleCommentsTrigger icon={<IconComment />} reference={article} variant="button" />
    </Container>
  );
};

HeaderFeaturesComment.displayName = "HeaderFeaturesComment";
